// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFirstElement } from 'clark-utils';

import {
  incrementPayerPage,
  getNewPayerAuthenticated,
  postNewPayerPaymentMethod,
} from 'actions/payer';

import Splash from 'components/payer/splash';
import CreditCardForm from 'components/payer/credit-card-form';
import Loader from 'components/loader';
import SectionHeader from 'components/shared/section-header';
import Layout from 'components/shared/layout';

import { RecieptEmailCopy } from 'components/payer/success/styles';

import { type StateType as ReducerStateType } from 'reducers';

import confirmNewPaymentMethod from './helpers';

const Success = ({ payer, business }: any) => (
  <Layout>
    <SectionHeader
      textAlign="center"
      headline={`Thanks, ${payer.attributes.firstName}!`}
      subHeadline={`You're payment method has been saved for ${business.attributes.name}`}
    />
    <RecieptEmailCopy>Receipts will be sent to {payer.attributes.email}</RecieptEmailCopy>
  </Layout>
);

const COMPONENTS = [Splash, CreditCardForm, Success];

type PropsFromStateType = {
  page: number,
  payer: *,
  business: *,
  isLoading: number,
  payerPath: string,
  payerCharge: *,
};

const mapStateToProps = ({
  payer,
  form,
  router,
  application,
}: ReducerStateType): PropsFromStateType => {
  const { page, data, business } = payer;
  const { payerCharge } = form;
  const { isLoading } = application;

  return {
    page,
    payerCharge,
    business,
    isLoading,
    payer: getFirstElement(data), // only returns one record
    query: router.location.search,
    payerPath: router.location.pathname,
  };
};

type DispatchPropsType = {
  dispatchIncrementPayerPage: typeof incrementPayerPage,
  dispatchGetNewPayerAuthenticated: typeof getNewPayerAuthenticated,
  dispatchPostNewPayerPaymentMethod: typeof postNewPayerPaymentMethod,
};

const mapDispatchToProps: DispatchPropsType = {
  dispatchIncrementPayerPage: incrementPayerPage,
  dispatchGetNewPayerAuthenticated: getNewPayerAuthenticated,
  dispatchPostNewPayerPaymentMethod: postNewPayerPaymentMethod,
};

type PropsType = DispatchPropsType & PropsFromStateType;

type StateType = {
  showNewCreditCardForm: boolean,
  pendingBankAccountAttributes: *,
};

class PayerSetup extends Component<PropsType, StateType> {
  constructor(props) {
    super(props);

    this.state = {
      showNewCreditCardForm: true,
      pendingBankAccountAttributes: undefined,
    };
  }

  componentWillMount() {
    const { payerPath, dispatchGetNewPayerAuthenticated } = this.props;

    try {
      const pathToken = payerPath.split('/setup-account/')[1].replace(/\//, '');
      dispatchGetNewPayerAuthenticated(pathToken);
    } catch (e) {
      // eslint-disable-next-line
      console.log(e);
    }
  }

  handleClick = stripe =>
    (async () => {
      const {
        page,
        dispatchIncrementPayerPage,
        payerCharge = {},
        dispatchPostNewPayerPaymentMethod,
      } = this.props;

      const { pendingBankAccountAttributes: bankAttributes } = this.state;

      const { values: formValues } = payerCharge;

      const isUserOnChargeScreen = page === 1;

      if (isUserOnChargeScreen) {
        const data = formValues;

        confirmNewPaymentMethod(data, stripe, bankAttributes, dispatchPostNewPayerPaymentMethod);
      } else {
        dispatchIncrementPayerPage();
      }
    })();

  handlePlaidSuccess = (bankAccountPublicToken, metadata) => {
    const {
      account: {
        id: bankAccountId,
        mask: bankAccountLast4,
        name: bankName,
        subtype: bankAccountType,
      },
    } = metadata;

    this.setState({
      pendingBankAccountAttributes: {
        bankAccountPublicToken,
        bankAccountId,
        bankAccountLast4,
        bankAccountType,
        bankName,
      },
    });
  };

  render() {
    const { page, payer, business, isLoading } = this.props;
    const { showNewCreditCardForm, pendingBankAccountAttributes } = this.state;
    const Container = COMPONENTS[page];

    const {
      attributes: { logoUrl },
    } = business;

    return isLoading ? (
      <Loader />
    ) : (
      <Container
        handleClick={this.handleClick}
        handlePlaidSuccess={this.handlePlaidSuccess}
        business={business}
        payer={payer}
        logoUrl={logoUrl}
        showNewCreditCardForm={showNewCreditCardForm}
        pendingBankAccountAttributes={pendingBankAccountAttributes}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PayerSetup);



// WEBPACK FOOTER //
// ./src/screens/payer-setup/index.js